import { FormFieldsConfig, commonFormFields } from '../types/formFields';
import { RetailerSelect } from '../../RetailerSelect/RetailerSelect';

export { defaultFormConfig } from './eventFormConfig';

const TRANSLATION_NS = 'appointments';

export const appointmentFormConfig: FormFieldsConfig = {
  'product-consultation': {
    fields: [
      commonFormFields.firstName,
      commonFormFields.lastName,
      commonFormFields.email,
      commonFormFields.phone,
      {
        id: 'streetAddress',
        type: 'text',
        label: 'Project Street Address',
        required: true,
        translationKey: `${TRANSLATION_NS}:form.streetAddress`,
        useGoogleAutocomplete: true
      },
      {
        id: 'city',
        type: 'text',
        label: 'City',
        required: true,
        translationKey: `${TRANSLATION_NS}:form.city`,
        useGoogleAutocomplete: true
      },
      {
        id: 'province',
        type: 'text',
        label: 'Province',
        required: true,
        translationKey: `${TRANSLATION_NS}:form.province`,
        useGoogleAutocomplete: true
      },
      {
        id: 'postalCode',
        type: 'text',
        label: 'Postal Code',
        required: true,
        translationKey: `${TRANSLATION_NS}:form.postalCode`,
        useGoogleAutocomplete: true
      },
      {
        id: 'visitedShowroom',
        type: 'radio',
        label: 'Have you visited our showrooms before? :',
        required: true,
        translationKey: `${TRANSLATION_NS}:form.visitedShowroom`,
        options: [
          { label: 'form.yes', value: 'yes' },
          { label: 'form.no', value: 'no' }
        ]
      },
      {
        id: 'productsInterested',
        type: 'text',
        label: 'Please list the products that you are interested in :',
        required: true,
        translationKey: `${TRANSLATION_NS}:form.productsInterested`,
      },
      {
        id: 'tradeProfessionals',
        type: 'text',
        label: 'Please list the names of any trade professionals you are working with (Designer, Architect, Builder) :',
        required: false,
        translationKey: `${TRANSLATION_NS}:form.tradeProfessionals`,
      },
      {
        id: 'retailer',
        type: 'select',
        label: 'Are you already working with an appliance retailer? If so, which one? Sales Rep? :',
        required: false,
        translationKey: `${TRANSLATION_NS}:form.retailer`,
        component: RetailerSelect
      },
      {
        id: 'additionalComments',
        type: 'textarea',
        label: 'Additional Comments :',
        required: false,
        translationKey: `${TRANSLATION_NS}:form.additionalComments`,
      }
    ],
    layout: {
      rows: [
        ['firstName', 'lastName'],
        ['email', 'phone'],
        ['streetAddress', 'postalCode'],
        ['city', 'province'],
        ['visitedShowroom', 'productsInterested'],
        ['tradeProfessionals', 'retailer'],
        ['additionalComments']
      ]
    }
  },
  'private-intro-class': {
    fields: [
      commonFormFields.firstName,
      commonFormFields.lastName,
      commonFormFields.email,
      commonFormFields.phone,
      {
        id: 'streetAddress',
        type: 'text',
        label: 'Project Street Address',
        required: true,
        translationKey: `${TRANSLATION_NS}:form.streetAddress`,
        useGoogleAutocomplete: true
      },
      {
        id: 'city',
        type: 'text',
        label: 'City',
        required: true,
        translationKey: `${TRANSLATION_NS}:form.city`,
        useGoogleAutocomplete: true
      },
      {
        id: 'province',
        type: 'text',
        label: 'Province',
        required: true,
        translationKey: `${TRANSLATION_NS}:form.province`,
        useGoogleAutocomplete: true
      },
      {
        id: 'postalCode',
        type: 'text',
        label: 'Postal Code',
        required: true,
        translationKey: `${TRANSLATION_NS}:form.postalCode`,
        useGoogleAutocomplete: true
      },
      {
        id: 'foodAllergies',
        type: 'text',
        label: 'Food Allergies / Dietary Restrictions',
        required: false,
        translationKey: `${TRANSLATION_NS}:form.foodAllergies`,
      },
      {
        id: 'guestName',
        type: 'text',
        label: 'Guest Name',
        required: false,
        translationKey: `${TRANSLATION_NS}:form.guestName`,
      },
      {
        id: 'productsInterested',
        type: 'text',
        label: 'Please list the products that you are interested in',
        required: true,
        translationKey: `${TRANSLATION_NS}:form.productsInterested`,
      },
      {
        id: 'tradeProfessionals',
        type: 'text',
        label: 'Please list the names of any trade professionals you are working with (Designer, Architect, Builder)',
        required: false,
        translationKey: `${TRANSLATION_NS}:form.tradeProfessionals`,
      },
      {
        id: 'retailer',
        type: 'select',
        label: 'Are you working with an appliance retailer? If so, which one?',
        required: false,
        translationKey: `${TRANSLATION_NS}:form.retailer`,
        component: RetailerSelect
      },
      {
        id: 'additionalComments',
        type: 'textarea',
        label: 'Additional Comments',
        required: false,
        translationKey: `${TRANSLATION_NS}:form.additionalComments`,
      }
    ],
    layout: {
      rows: [
        ['firstName', 'lastName'],
        ['email', 'phone'],
        ['streetAddress', 'postalCode'],
        ['city', 'province'],
        ['foodAllergies', 'guestName'],
        ['productsInterested', 'tradeProfessionals'],
        ['retailer', 'additionalComments']
      ]
    }
  },
  'private-ownership': {
    fields: [
      commonFormFields.firstName,
      commonFormFields.lastName,
      commonFormFields.email,
      commonFormFields.phone,
      {
        id: 'streetAddress',
        type: 'text',
        label: 'Project Street Address',
        required: true,
        translationKey: `${TRANSLATION_NS}:form.streetAddress`,
        useGoogleAutocomplete: true
      },
      {
        id: 'city',
        type: 'text',
        label: 'City',
        required: true,
        translationKey: `${TRANSLATION_NS}:form.city`,
        useGoogleAutocomplete: true
      },
      {
        id: 'province',
        type: 'text',
        label: 'Province',
        required: true,
        translationKey: `${TRANSLATION_NS}:form.province`,
        useGoogleAutocomplete: true
      },
      {
        id: 'postalCode',
        type: 'text',
        label: 'Postal Code',
        required: true,
        translationKey: `${TRANSLATION_NS}:form.postalCode`,
        useGoogleAutocomplete: true
      },
      {
        id: 'foodAllergies',
        type: 'text',
        label: 'Food Allergies / Dietary Restrictions',
        required: false,
        translationKey: `${TRANSLATION_NS}:form.foodAllergies`,
      },
      {
        id: 'guestName',
        type: 'text',
        label: 'Guest Name',
        required: false,
        translationKey: `${TRANSLATION_NS}:form.guestName`,
      },
      {
        id: 'productsOwned',
        type: 'text',
        label: 'Please list the products you own relevant to this class',
        required: true,
        translationKey: `${TRANSLATION_NS}:form.productsOwned`,
      },
      {
        id: 'additionalComments',
        type: 'textarea',
        label: 'Additional Comments',
        required: false,
        translationKey: `${TRANSLATION_NS}:form.additionalComments`,
      }
    ],
    layout: {
      rows: [
        ['firstName', 'lastName'],
        ['email', 'phone'],
        ['streetAddress', 'postalCode'],
        ['city', 'province'],
        ['foodAllergies', 'guestName'],
        ['productsOwned', 'retailer'],
        ['additionalComments']
      ]
    }
  },
  'boardroom-meeting': {
    fields: [
      commonFormFields.firstName,
      commonFormFields.lastName,
      commonFormFields.email,
      commonFormFields.phone,
      {
        id: 'meetingDetails',
        type: 'text',
        label: 'Meeting Details',
        required: true,
        translationKey: `${TRANSLATION_NS}:form.meetingDetails`,
      },
      {
        id: 'audioVideoRequirements',
        type: 'text',
        label: 'Audio / Video Requirements',
        required: false,
        translationKey: `${TRANSLATION_NS}:form.audioVideoRequirements`,
      },
      {
        id: 'cateringRequirements',
        type: 'text',
        label: 'Catering Requirements',
        required: false,
        translationKey: `${TRANSLATION_NS}:form.cateringRequirements`,
      },
      {
        id: 'additionalComments',
        type: 'textarea',
        label: 'Additional Comments',
        required: false,
        translationKey: `${TRANSLATION_NS}:form.additionalComments`,
      }
    ],
    layout: {
      rows: [
        ['firstName', 'lastName'],
        ['email', 'phone'],
        ['meetingDetails', 'audioVideoRequirements'],
        ['cateringRequirements', 'additionalComments']
      ]
    }
  },
  'builder-package-viewing': {
    fields: [
      commonFormFields.firstName,
      commonFormFields.lastName,
      commonFormFields.email,
      commonFormFields.phone,
      {
        id: 'developer',
        type: 'text',
        label: 'Developer',
        required: true,
        translationKey: `${TRANSLATION_NS}:form.developer`,
      },
      {
        id: 'siteName',
        type: 'text',
        label: 'Site Name',
        required: true,
        translationKey: `${TRANSLATION_NS}:form.siteName`,
      },
      {
        id: 'lotSuiteNumber',
        type: 'text',
        label: 'Lot / Suite Number',
        required: true,
        translationKey: `${TRANSLATION_NS}:form.lotSuiteNumber`,
      },
      {
        id: 'productsInterested',
        type: 'text',
        label: 'Please list the products that you are interested in',
        required: true,
        translationKey: `${TRANSLATION_NS}:form.productsInterested`,
      },
      {
        id: 'additionalComments',
        type: 'textarea',
        label: 'Additional Comments',
        required: false,
        translationKey: `${TRANSLATION_NS}:form.additionalComments`,
      }
    ],
    layout: {
      rows: [
        ['firstName', 'lastName'],
        ['email', 'phone'],
        ['developer', 'siteName'],
        ['lotSuiteNumber', 'productsInterested'],
        ['additionalComments']
      ]
    }
  }
};
